import type { FC } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  CircularProgress,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

import type { DetailedFollowUpTicket } from 'src/types/followUp';
import type { ActionItemSelection } from 'src/types/myFollowUp';
import ActionItemNavigationButtons from 'src/components/myFollowUp/MyFollowUpPage/FollowUpOverview/components/ActionItemNavigationButtons';

import useFollowUpTable from '../FollowUpTable/FollowUpTableContext';

import { styles } from './TicketDetailModalHeader.styles';
import { styles as modalStyles } from 'src/components/followUp/TicketOverviewPage/TicketDetail/ticketDetail.styles';

const TicketDetailModalHeader: FC<{
  ticket?: DetailedFollowUpTicket;
  closeModal: () => void;
  onRowSelect: (selectedRow: ActionItemSelection) => void;
}> = ({ ticket, closeModal, onRowSelect }) => {
  const { t } = useTranslation('common');
  const { setOffset, ordering, offset, actionItems, pageSize } =
    useFollowUpTable();

  return (
    <Box sx={modalStyles.modalHeader}>
      <Box display="flex" alignItems="center" gap={2}>
        <ActionItemNavigationButtons
          onRowSelect={onRowSelect}
          currentActionItemId={ticket?.id}
          setOffset={setOffset}
          actionItems={actionItems}
          offset={offset}
          ordering={ordering}
          pageSize={pageSize}
          useActionContext={false}
        />
        <Typography sx={(theme) => ({ color: theme.colors.neutral[500] })}>
          {!!ticket?.id && t('id', { id: ticket.id })}
        </Typography>
        {ticket?.respondent ? (
          <DialogTitle variant="h4">{ticket.respondent.name}</DialogTitle>
        ) : (
          <CircularProgress size="small" sx={styles.loading} />
        )}
      </Box>
      <IconButton onClick={closeModal}>
        <CloseIcon fontSize="small" color="primary" />
      </IconButton>
    </Box>
  );
};

export default TicketDetailModalHeader;
